<script setup lang="ts">
import { onMounted } from 'vue'
import { PhMoon, PhSun } from '@phosphor-icons/vue'

import type { Theme } from '../types'
import { getTheme, setTheme } from '../composables/theme'

function toggleTheme(): void {
    const current = getTheme()
    const newTheme: Theme = current === 'dark' ? 'light' : 'dark'

    setTheme(newTheme)
    document.documentElement.setAttribute('data-theme', newTheme)
}

onMounted(() => {
    const theme = getTheme()
    document.documentElement.setAttribute('data-theme', theme)
})
</script>

<template>
    <button
        id="theme-toggle"
        class="absolute top-3 left-3 flex size-10 cursor-pointer items-center justify-center rounded-lg border border-zinc-300 bg-zinc-100 text-neutral-600 transition-transform hover:bg-zinc-300 active:scale-95 dark:border-zinc-800 dark:bg-zinc-900 dark:text-neutral-200 dark:hover:bg-zinc-800"
        @click="toggleTheme"
    >
        <PhSun :size="18" class="hidden dark:block" />
        <PhMoon :size="18" class="block dark:hidden" />
    </button>
</template>
